"use client";

import { CookiePreferencesButton } from "@pex/cookie-consent/client";
import { PexLogo } from "@pex/design-tokens";
import { Link2 } from "lucide-react";
import Image from "next/image";
import Link from "next/link";

const SOCIAL_LINKS = [
  {
    label: "WhatsApp",
    href: "https://wa.me/+27826923999",
    icon: "/icons/social/whatsapp.svg",
  },
  {
    label: "Facebook",
    href: "https://www.facebook.com/projectexodusrecovery",
    icon: "/icons/social/facebook.svg",
  },
  {
    label: "Instagram",
    href: "https://www.instagram.com/projectexodusrecovery/",
    icon: "/icons/social/instagram.svg",
  },
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/company/projectexodusrecovery/",
    icon: "/icons/social/linkedin.svg",
  },
  {
    label: "YouTube",
    href: "https://www.youtube.com/@projectexodusrecovery",
    icon: "/icons/social/youtube.svg",
  },
  {
    label: "TikTok",
    href: "https://www.tiktok.com/@pexrecovery",
    icon: "/icons/social/tiktok.svg",
  },
] as const;

export function SgfFooter() {
  const handleCopy = () => {
    if (typeof window !== "undefined") {
      navigator.clipboard.writeText(window.location.href);
    }
  };

  return (
    <footer className="bg-white">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-6 px-4 py-10 sm:flex-row sm:px-6 lg:px-8">
        {/* Logo */}
        <Link aria-label="Project Exodus home" href="/">
          <PexLogo className="h-10 w-auto" />
        </Link>

        {/* Share + social icons */}
        <div className="flex items-center gap-4">
          <span className="font-medium text-muted-foreground text-sm">
            Share:
          </span>
          <button
            aria-label="Copy page link"
            className="opacity-60 transition-opacity hover:opacity-100"
            onClick={handleCopy}
            type="button"
          >
            <Link2 className="h-5 w-5" />
          </button>
          {SOCIAL_LINKS.map(({ label, href, icon }) => (
            <a
              aria-label={label}
              className="opacity-60 transition-opacity hover:opacity-100"
              href={href}
              key={label}
              rel="noopener noreferrer"
              target="_blank"
            >
              <Image
                alt=""
                aria-hidden="true"
                height={20}
                src={icon}
                width={20}
              />
            </a>
          ))}
        </div>
      </div>

      {/* Bottom bar */}
      <div>
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-4 py-4 text-muted-foreground text-sm sm:flex-row sm:px-6 lg:px-8">
          <p>© 2026 Project Exodus. All rights reserved.</p>
          <div className="flex flex-col items-center gap-y-2 sm:flex-row sm:gap-x-4">
            <Link
              className="transition-colors hover:text-foreground"
              href="/legal/privacy-policy"
            >
              Privacy Policy
            </Link>
            <Link
              className="transition-colors hover:text-foreground"
              href="/legal/terms-service"
            >
              Terms of Service
            </Link>
            <CookiePreferencesButton className="h-auto p-0 font-normal text-muted-foreground hover:bg-transparent hover:text-foreground" />
          </div>
        </div>
      </div>
    </footer>
  );
}
